import { AccessTimeOutlined, DateRangeOutlined, MoreVertOutlined, ViewTimelineOutlined } from '@mui/icons-material';
import {  alpha, Grid, IconButton, Menu, MenuItem, styled, Typography } from '@mui/material';
import Localization from 'l18n/l18n';
import * as React from 'react';
import AvailableTimeDialog from './calendar_settings/available_time_dialog_content';
import CalendarSettinsDialog from './calendar_settings/dialog';
import ExceptionsDialog from './calendar_settings/exceptions_dialog_content';
import WeekendDaySelectorDialog from './calendar_settings/weekend_selector_dialog_content';

const CalendarHeader = ({dialogs,changeDialogsOpenState})=>{
  const [isMenuOpen, setIsMenuOpen] = React.useState(null);
 

  const open = Boolean(isMenuOpen);
  const handleClick = (event) => {
    setIsMenuOpen(event.currentTarget);
  };
  const handleClose = () => {
    setIsMenuOpen(null);
  };




  const handleItemClick = (item)=>{
    if(!item.target.attributes.dialogid) return ;
    switch(Number(item.target.attributes.dialogid.value)){
      case 3:
        changeDialogsOpenState('WeekendOpen',true);
        break;
      case 2:
        changeDialogsOpenState('exceptionsOpen',true);
        break;
      case 1:
        changeDialogsOpenState('availableTimeOpen',true);
        break;
      default:
        break;
    }
    handleClose() ;
  };
  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));

    return (
      <>
        <Grid sx={{ mb: 8, justify: 'center' }} spacing={4} item container>
        <Grid container item md={6} xs={12} sx={{ alignItems: 'center' }}>
          <Typography component="h4" variant="h4" color="#000000">
            {Localization.translate['appointments_calendar']}
          </Typography>

          <Typography >
            {Localization.translate['calendar_add_appointment']}
          </Typography>
        </Grid>


        <Grid item md={6} xs={12} sx={{ textAlign: { xs: 'center', md: 'end' } }} >
          <IconButton disableRipple onClick={handleClick} >
            <MoreVertOutlined sx={{color:'#279BFF'}} />
          </IconButton>
          <StyledMenu
        anchorEl={isMenuOpen}
        open={open}
        onClose={handleClose}
        >
        <MenuItem onClick={handleItemClick} dialogid={1} disableRipple>
          <AccessTimeOutlined  onClick={handleItemClick}  dialogid={1} />
          {Localization.translate['available_time']}
        </MenuItem>
        <MenuItem onClick={handleItemClick} dialogid={2} disableRipple>
          <ViewTimelineOutlined  onClick={handleItemClick} dialogid={2} />
          {Localization.translate['exceptions']}
        </MenuItem>
        <MenuItem onClick={handleItemClick} dialogid={3} disableRipple>
          <DateRangeOutlined onClick={handleItemClick} dialogid={3} />
          {Localization.translate['vications']}
        </MenuItem>
      </StyledMenu>
        </Grid>
      </Grid>

      <CalendarSettinsDialog open={dialogs.WeekendOpen} handleClose={()=>changeDialogsOpenState('WeekendOpen',false)}>
          <WeekendDaySelectorDialog />
      </CalendarSettinsDialog>

 
       <CalendarSettinsDialog open={dialogs.exceptionsOpen} handleClose={()=>changeDialogsOpenState('exceptionsOpen',false)}>
        <ExceptionsDialog  />
      </CalendarSettinsDialog>

      <CalendarSettinsDialog open={dialogs.availableTimeOpen} handleClose={()=>changeDialogsOpenState('availableTimeOpen',false)}>
        <AvailableTimeDialog />
      </CalendarSettinsDialog>  
      
     
        </>
    );
};

export default CalendarHeader ;